import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Experience } from '../../../services/interfaces/experiences';

@Component({
  selector: 'app-experience-map-v2',
  templateUrl: './experience-map-v2.component.html',
  styleUrl: './experience-map-v2.component.scss'
})
export class ExperienceMapV2Component implements OnInit, OnChanges {
  @Input() experience: Experience | undefined;
  @Input() latitude!: number;
  @Input() longitude!: number;

  public mapUrl: SafeResourceUrl | string = '';
  public directionsUrl: string = '';
  public addressText: string = '';
  public isLoading: boolean = true;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.updateMapUrl();
    this.updateAddress();
    this.updateDirectionsUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['experience'] || changes['latitude'] || changes['longitude']) {
      this.updateMapUrl();
      this.updateAddress();
      this.updateDirectionsUrl();
    }
  }

  private updateMapUrl(): void {
    let lat: number | undefined;
    let lng: number | undefined;

    // Priority: use input coordinates if provided, otherwise use experience coordinates
    if (this.latitude && this.longitude) {
      lat = this.latitude;
      lng = this.longitude;
    } else if (this.experience?.details?.place?.lat && this.experience?.details?.place?.lng) {
      lat = this.experience.details.place.lat;
      lng = this.experience.details.place.lng;
    }

    if (lat && lng) {
      // Google Maps iframe embed URL (no API key required)
      // Using the embed format: https://maps.google.com/maps?q=lat,lng&output=embed
      const url = `https://maps.google.com/maps?q=${lat},${lng}&hl=en&z=14&output=embed`;
      this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.isLoading = true; // Reset loading state when URL changes
    } else {
      this.mapUrl = '';
      this.isLoading = false;
    }
  }

  onMapLoad(): void {
    this.isLoading = false;
  }

  private updateAddress(): void {
    if (!this.experience?.details?.place) {
      this.addressText = '';
      return;
    }

    const place = this.experience.details.place;
    const addressParts: string[] = [];

    if (place.street) addressParts.push(place.street);
    if (place.city) addressParts.push(place.city);
    if (place.province) addressParts.push(place.province);
    if (place.zipcode) addressParts.push(`- ${place.zipcode}`);

    this.addressText = addressParts.join(', ');
  }

  private updateDirectionsUrl(): void {
    let lat: number | undefined;
    let lng: number | undefined;

    // Priority: use input coordinates if provided, otherwise use experience coordinates
    if (this.latitude && this.longitude) {
      lat = this.latitude;
      lng = this.longitude;
    } else if (this.experience?.details?.place?.lat && this.experience?.details?.place?.lng) {
      lat = this.experience.details.place.lat;
      lng = this.experience.details.place.lng;
    }

    if (lat && lng) {
      // Google Maps directions URL (no API key required)
      this.directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    } else {
      this.directionsUrl = '';
    }
  }
}
